import styles from './Corporate.module.scss';
/**
 * Render Corporate
 *
 * @return {Element} Corporate component
 */
export default function Corporate() {
  return (
    <div className={styles.corporate}>
      <ul>
        <li>
          <a href="https://cnn.com/terms">Terms of Use</a>
        </li>
        <li>
          <a href="https://www.cnn.com/privacy">Privacy Policy</a>
        </li>
        <li>
          <a href="https://www.cnn.com/?refresh=1">Do Not Sell My Personal Information</a>
        </li>
        <li>
          <a href="https://www.cnn.com/?refresh=1">AdChoices</a>
        </li>
        <li>
          <a href="https://www.cnn.com/about">About Us</a>
        </li>
        <li>
          <a href="https://store.cnn.com/">CNN Store</a>
        </li>
        <li>
          <a href="https://www.cnn.com/newsletters">Newsletters</a>
        </li>
        <li>
          <a href="http://transcripts.cnn.com/TRANSCRIPTS/">Transcripts</a>
        </li>
        <li>
          <a href="https://collection.cnn.com/">License Footage</a>
        </li>
        <li>
          <a href="https://www.cnnnewsource.com/">CNN Newsource</a>
        </li>
        <li>
          <a href="https://www.cnn.com/sitemap.html">Sitemap</a>
        </li>
      </ul>
      <p>&copy; 2021 Cable News Network. A Warner Media Company. All Rights Reserved.</p>
      <p>CNN Sans ™ &amp; © 2016 Cable News Network.</p>
    </div>
  );
}
